export class MultiLineTextSerializableValue {
  value?: string;

  constructor(value?: string) {
    this.value = value;
  }
}
